export const isIFrame=e=>null!==e&&"IFRAME"===e.tagName;